import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {

  vendingCategoryList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isLoadingVendingCategory: false,
  vendingCategoryListAll: [],  
  isVendingCategoryAddSuccess: false,
  isVendingCategoryAddFail: false,
  isVendingCategoryEditSuccess: false,
  isVendingCategoryEditFail: false,
  isVendingCategoryRemoveSuccess: false,

  vendingPriceEffectiveDateList: {},
  vendingPriceControlList: [],
  isVendingPriceControlSetSuccess: false,
  isVendingPriceControlSetFail: false,
  isVendingPriceRemoveSuccess: false,
  vendingPriceRemoveConfirm: null,
  vendingPricePDF: "",

  graderVendingCount: {},
  graderVendingList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGraderVending: false,
  vendingLocationList: [],
  isProcessLoadVendingLocationList: false,
  vendingBagList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadVendingBagList: false,
  isLoadingDeviceStatusList: false,
  vendingDeviceStatus: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
    }
  },
  vendingActivationList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
    }
  },
  vendingUploadedLogs: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
    }
  },
  isErrorLogResolvedSuccess: false,
  isErrorLogResolvedFail: false,
  graderVendingDetail: {},
  isProcessLoadGraderVendingDetail: false,
  isGraderVendingApprovedSuccess: false,
  isGraderVendingApprovedFail: false,
  isGraderVendingCreateSuccess: false,
  isGraderVendingUpdateSuccess: false,
  isGraderVendingResetPwdSuccess: false,
  isGraderVendingRemoveSuccess: false,
  isGraderVendingPublishSuccess: false,
  isGraderVendingResidentOnlySuccess: false,
  isGraderVendingRebootSuccess: false,
  isGraderVendingUnlockMaglockSuccess: false,
  isGraderVendingCurrentStatusSuccess: false,
  vendingBagCount: {},
  isVendingBagRollbackOverflowSuccess: false,
  isVendingBagConfirmTripFillingSuccess: false,
  isVendingBagForceTripFillingSuccess: false,
  isGraderVendingStopServiceSuccess: false,
  isGraderVendingStartServiceSuccess: false,
  isGraderVendingTestConnectionSuccess: false,
  isGraderVendingCurrentWeightSuccess: false,
  isGraderVendingCurrentWeightFail: false,
  graderVendingCurrentWeight: null,
  vendingLandfillDistance: null,
  isProcessVendingLandfillDistance: false,
  isLoadingAudioTTSList: false,
  audioTTSList: [],
  isGraderVendingAudioTTSUpdateSuccess: false,
  isResetMQTTTopicSuccess: false,
  isProcessResetMQTTTopic: false,
  isCancelStuckExpressOrderSuccess: false,
  isProcessCancelStuckExpressOrder: false,
  
  isLoadingDRVMGradingOrderDashboard: false,
  DRVMGradingOrderDashboard: {},
  isLoadingDRVMGradingVendingDashboard: false,
  DRVMGradingVendingDashboard: {},
  isLoadingDRVMGradingStatusChart: false,
  DRVMGradingStatusChart: {},
  isLoadingDRVMGradingOrderChart: false,
  isLoadDRVMGradingOrderChartSuccess: false,
  DRVMGradingOrderChart: [],
  isLoadingDRVMGradingRanking: false,
  DRVMGradingRankingVending: [],
  DRVMGradingRankingLocation: [],
  isLoadingDRVMGradingCategoryChart: false,
  DRVMGradingCategoryChart: [],

  vendingCouncilList: [],
  isLoadingVendingCouncilList: false,
  isVendingCouncilCreateSuccess: false,
  isVendingCouncilCreateFail: false,
  isVendingCouncilUpdateSuccess: false,
  isVendingCouncilUpdateFail: false,
  isVendingCouncilRemoveSuccess: false,
  isVendingCouncilRemoveFail: false,
  isVendingCouncilSetSuccess: false,
  isVendingCouncilSetFail: false,

  vendingVersionList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isLoadingVendingVersionList: false,
  isVendingVersionUploadSuccess: false,
  isVendingVersionUploadFail: false,
  isVendingVersionSelectSuccess: false,
  isVendingVersionSelectFail: false,
  isVendingVersionSendSuccess: false,
  isVendingVersionSendFail: false,
  isVendingVersionRemoveSuccess: false,
  isVendingVersionRemoveFail: false,
  drvmRecyclingCategory: [],
  isUpdateCategoryRulesSuccess: false,
  isUpdateCategoryRulesFail: false,
};

export default function recyclingReducer(state = initState, action) {

  switch (action.type) {
        
    case actionTypes.LOAD_VENDING_CATEGORY: {
      
      let vendingCategoryList = cloneDeep(state.vendingCategoryList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        vendingCategoryList.offset = action.data.offset;
        vendingCategoryList.limit = action.data.limit;
      }

      return {
        ...state,
        vendingCategoryList
      };
    }

    case actionTypes.LOAD_VENDING_CATEGORY_SUCCESS: {
  
      let vendingCategoryList = cloneDeep(state.vendingCategoryList);
      vendingCategoryList.data = action.data.data;
      vendingCategoryList.meta = {
        page: 1 + state.vendingCategoryList.offset / state.vendingCategoryList.limit,
        pageSize: state.vendingCategoryList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.vendingCategoryList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        vendingCategoryList
      };
    }

    case actionTypes.LOAD_VENDING_CATEGORY_FAIL: {
      return {
        ...state,
      };
    }
    
    
    case actionTypes.LOAD_VENDING_CATEGORY_ALL: {
      
      return {
        ...state,
        isLoadingVendingCategory: true,
        vendingCategoryListAll: []
      };
    }

    case actionTypes.LOAD_VENDING_CATEGORY_ALL_SUCCESS: {
  
      return {
        ...state,
        isLoadingVendingCategory: false,
        vendingCategoryListAll: action.data
      };
    }

    case actionTypes.LOAD_VENDING_CATEGORY_ALL_FAIL: {
      return {
        ...state,
        isLoadingVendingCategory: false,
      };
    }

    case actionTypes.ADD_VENDING_CATEGORY: {
      return {
        ...state,
        isVendingCategoryAddSuccess: false,
        isVendingCategoryAddFail: false,
      };
    }

    case actionTypes.ADD_VENDING_CATEGORY_SUCCESS: {
      return {
        ...state,
        isVendingCategoryAddSuccess: true
      };
    }

    case actionTypes.ADD_VENDING_CATEGORY_FAIL: {
      return {
        ...state,
        isVendingCategoryAddFail: true
      };
    }


    case actionTypes.EDIT_VENDING_CATEGORY: {
      return {
        ...state,
        isVendingCategoryEditSuccess: false,
        isVendingCategoryEditFail: false,
      };
    }

    case actionTypes.EDIT_VENDING_CATEGORY_SUCCESS: {
      return {
        ...state,
        isVendingCategoryEditSuccess: true
      };
    }

    case actionTypes.EDIT_VENDING_CATEGORY_FAIL: {
      return {
        ...state,
        isVendingCategoryEditFail: true
      };
    }
    

    case actionTypes.DELETE_VENDING_CATEGORY: {
      return {
        ...state,
        isVendingCategoryRemoveSuccess: false
      };
    }

    case actionTypes.DELETE_VENDING_CATEGORY_SUCCESS: {
      return {
        ...state,
        isVendingCategoryRemoveSuccess: true
      };
    }

    case actionTypes.DELETE_VENDING_CATEGORY_FAIL: {
      return {
        ...state,
        isVendingCategoryRemoveSuccess: false
      };
    }
    
    
    case actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST: {
    
      return {
        ...state,
        vendingPriceEffectiveDateList: {},
      };
    }

    case actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST_SUCCESS: {
      
      return {
        ...state,
        vendingPriceEffectiveDateList: action.data,
      };
    }

    case actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST_FAIL: {
      return {
        ...state,
        vendingPriceEffectiveDateList: {},
      };
    }

    case actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD: {
      return {
        ...state,
        vendingPriceControlList:[],
      };
    }

    case actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD_SUCCESS: {
      return {
        ...state,
        vendingPriceControlList: action.data,
      };
    }

    case actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD_FAIL: {
      return {
        ...state
      };
    }


    case actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET: {
      return {
        ...state,
        isVendingPriceControlSetSuccess: false,
        isVendingPriceControlSetFail: false
      };
    }

    case actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET_SUCCESS: {
      return {
        ...state,
        isVendingPriceControlSetSuccess: true
      };
    }

    case actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET_FAIL: {
      return {
        ...state,
        isVendingPriceControlSetFail: true
      };
    }
    

    case actionTypes.DELETE_VENDING_CATEGORY_PRICE: {
      return {
        ...state,
        isVendingPriceRemoveSuccess: false,
        vendingPriceRemoveConfirm: null
      };
    }

    case actionTypes.DELETE_VENDING_CATEGORY_PRICE_SUCCESS: {
      
      return {
        ...state,
        isVendingPriceRemoveSuccess: (action.data) ? false : true,
        vendingPriceRemoveConfirm: (action.data) ? action.data : null
      };
    }

    case actionTypes.DELETE_VENDING_CATEGORY_PRICE_FAIL: {
      return {
        ...state,
        isVendingPriceRemoveSuccess: false
      };
    }
    
    
    case actionTypes.GET_VENDING_CATEGORY_PRICE_PDF: {
      
      return {
        ...state,
        vendingPricePDF: ""
      };
    }

    case actionTypes.GET_VENDING_CATEGORY_PRICE_PDF_SUCCESS: {
      
      return {
        ...state,
        vendingPricePDF: action.data
      };
    }

    case actionTypes.GET_VENDING_CATEGORY_PRICE_PDF_FAIL: {
      return {
        ...state
      };
    }

    /* GRADER VENDING */
    case actionTypes.GRADER_VENDING_COUNT: {
    
      return {
        ...state,
        graderVendingCount: {}
      };
    }

    case actionTypes.GRADER_VENDING_COUNT_SUCCESS: {
     
      return {
        ...state,
        graderVendingCount: action.data
      };
    }

    case actionTypes.GRADER_VENDING_COUNT_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.GRADER_VENDING_LIST: {
      let graderVendingList = cloneDeep(state.graderVendingList);
      if (
        action.data && 
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderVendingList.offset = action.data.offset;
        graderVendingList.limit = action.data.limit;
      }

      return {
        ...state,
        graderVendingList,
        isProcessLoadGraderVending: true
      };
    }

    case actionTypes.GRADER_VENDING_LIST_SUCCESS: {
  
      let graderVendingList = cloneDeep(state.graderVendingList);
      graderVendingList.data = action.data.data;
      graderVendingList.meta = {
        page: 1 + state.graderVendingList.offset / state.graderVendingList.limit,
        pageSize: state.graderVendingList.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.graderVendingList.limit),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        graderVendingList,
        isProcessLoadGraderVending:false,
      };
    }

    case actionTypes.GRADER_VENDING_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadGraderVending:false,
      };
    }

    case actionTypes.GRADER_VENDING_LOCATION_LIST: {
      return {
        ...state,
        vendingLocationList: [],
        isProcessLoadVendingLocationList: true,
      };
    }

    case actionTypes.GRADER_VENDING_LOCATION_LIST_SUCCESS: {
      return {
        ...state,
        vendingLocationList: action.data,
        isProcessLoadVendingLocationList: false,
      };
    }

    case actionTypes.GRADER_VENDING_LOCATION_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadVendingLocationList: false,
      };
    }

    case actionTypes.GRADER_VENDING_BAG_LIST: {
      let vendingBagList = cloneDeep(state.vendingBagList);
      if (
        action.data && 
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        vendingBagList.offset = action.data.offset;
        vendingBagList.limit = action.data.limit;
      }

      return {
        ...state,
        vendingBagList,
        isProcessLoadVendingBagList: true
      };
    }

    case actionTypes.GRADER_VENDING_BAG_LIST_SUCCESS: {
      let vendingBagList = cloneDeep(state.vendingBagList);
      vendingBagList.data = action.data.data;
      vendingBagList.meta = {
        page: 1 + state.vendingBagList.offset / state.vendingBagList.limit,
        pageSize: state.vendingBagList.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.vendingBagList.limit),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        vendingBagList,
        isProcessLoadVendingBagList:false,
      };
    }

    case actionTypes.GRADER_VENDING_BAG_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadVendingBagList: false,
      };
    }

    case actionTypes.GRADER_VENDING_BAG_COUNT_SUCCESS: {
      return {
        ...state,
        vendingBagCount: action.data
      };
    }

    case actionTypes.GRADER_VENDING_BAG_COUNT_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW: {
      return {
        ...state,
        isVendingBagRollbackOverflowSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW_SUCCESS: {
      return {
        ...state,
        isVendingBagRollbackOverflowSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW_FAIL: {
      return {
        ...state,
        isVendingBagRollbackOverflowSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING: {
      return {
        ...state,
        isVendingBagConfirmTripFillingSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING_SUCCESS: {
      return {
        ...state,
        isVendingBagConfirmTripFillingSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING_FAIL: {
      return {
        ...state,
        isVendingBagConfirmTripFillingSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING: {
      return {
        ...state,
        isVendingBagForceTripFillingSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING_SUCCESS: {
      return {
        ...state,
        isVendingBagForceTripFillingSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING_FAIL: {
      return {
        ...state,
        isVendingBagForceTripFillingSuccess: false
      };
    }
        
    case actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST: {
      let vendingDeviceStatus = cloneDeep(state.vendingDeviceStatus);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        vendingDeviceStatus.offset = action.data.offset;
        vendingDeviceStatus.limit = action.data.limit;
      }

      if(action.data.offset === 0)
        vendingDeviceStatus.data = []

      return {
        ...state,
        vendingDeviceStatus
      };
    }

    case actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST_SUCCESS: {
      let vendingDeviceStatus = cloneDeep(state.vendingDeviceStatus);
      action.data.data.map(row => vendingDeviceStatus.data.push(row))
      vendingDeviceStatus.meta = {
        page: 1 + state.vendingDeviceStatus.offset / state.vendingDeviceStatus.limit,
        pageSize: state.vendingDeviceStatus.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.vendingDeviceStatus.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        vendingDeviceStatus
      };
    }

    case actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST_FAIL: {
      return {
        ...state,
      };
    }

    case actionTypes.GRADER_VENDING_ACTIVATION_LIST: {
      let vendingActivationList = cloneDeep(state.vendingActivationList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        vendingActivationList.offset = action.data.offset;
        vendingActivationList.limit = action.data.limit;
      }

      return {
        ...state,
        vendingActivationList
      };
    }

    case actionTypes.GRADER_VENDING_ACTIVATION_LIST_SUCCESS: {
      let vendingActivationList = cloneDeep(state.vendingActivationList);
      vendingActivationList.data = action.data.data;
      vendingActivationList.meta = {
        page: 1 + state.vendingActivationList.offset / state.vendingActivationList.limit,
        pageSize: state.vendingActivationList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.vendingActivationList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        vendingActivationList
      };
    }

    case actionTypes.GRADER_VENDING_ACTIVATION_LIST_FAIL: {
      return {
        ...state,
      };
    }
        
    case actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST: {
      let vendingUploadedLogs = cloneDeep(state.vendingUploadedLogs);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        vendingUploadedLogs.offset = action.data.offset;
        vendingUploadedLogs.limit = action.data.limit;
      }

      if(action.data.offset === 0)
        vendingUploadedLogs.data = []

      return {
        ...state,
        vendingUploadedLogs
      };
    }

    case actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST_SUCCESS: {
      let vendingUploadedLogs = cloneDeep(state.vendingUploadedLogs);
      vendingUploadedLogs.data = action.data.data;
      vendingUploadedLogs.meta = {
        page: 1 + state.vendingUploadedLogs.offset / state.vendingUploadedLogs.limit,
        pageSize: state.vendingUploadedLogs.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.vendingUploadedLogs.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        vendingUploadedLogs
      };
    }

    case actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST_FAIL: {
      return {
        ...state,
      };
    }
    
    case actionTypes.ERROR_LOG_RESOLVED: {
      return {
        ...state,
        isErrorLogResolvedSuccess: false,
        isErrorLogResolvedFail: false
      };
    }

    case actionTypes.ERROR_LOG_RESOLVED_SUCCESS: {
      return {
        ...state,
        isErrorLogResolvedSuccess: true
      };
    }

    case actionTypes.ERROR_LOG_RESOLVED_FAIL: {
      return {
        ...state,
        isErrorLogResolvedFail: true
      };
    }
    
    
    case actionTypes.GRADER_VENDING_DETAIL: {
      return {
        ...state,
        graderVendingDetail: {},
        isProcessLoadGraderVendingDetail: true
      };
    }

    case actionTypes.GRADER_VENDING_DETAIL_SUCCESS: {
      return {
        ...state,
        graderVendingDetail: action.data,
        isProcessLoadGraderVendingDetail: false
      };
    }

    case actionTypes.GRADER_VENDING_DETAIL_FAIL: {
      return {
        ...state,
        isProcessLoadGraderVendingDetail: false
      };
    }
    
    case actionTypes.GRADER_VENDING_APPROVE: {
      return {
        ...state,
        isGraderVendingApprovedSuccess: false,
        isGraderVendingApprovedFail: false
      };
    }

    case actionTypes.GRADER_VENDING_APPROVE_SUCCESS: {
      return {
        ...state,
        isGraderVendingApprovedSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_APPROVE_FAIL: {
      return {
        ...state,
        isGraderVendingApprovedFail: true
      };
    }
    
    case actionTypes.GRADER_VENDING_CREATE: {
      return {
        ...state,
        isGraderVendingCreateSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_CREATE_SUCCESS: {
      return {
        ...state,
        isGraderVendingCreateSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_CREATE_FAIL: {
      return {
        ...state,
        isGraderVendingCreateSuccess: false
      };
    }
    
    case actionTypes.GRADER_VENDING_EDIT: {
      return {
        ...state,
        isGraderVendingUpdateSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_EDIT_SUCCESS: {
      return {
        ...state,
        isGraderVendingUpdateSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_EDIT_FAIL: {
      return {
        ...state,
        isGraderVendingUpdateSuccess: false
      };
    }
    
    case actionTypes.GRADER_VENDING_RESET_PWD: {
      return {
        ...state,
        isGraderVendingResetPwdSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_RESET_PWD_SUCCESS: {
      return {
        ...state,
        isGraderVendingResetPwdSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_RESET_PWD_FAIL: {
      return {
        ...state,
        isGraderVendingResetPwdSuccess: false
      };
    }
    
    case actionTypes.GRADER_VENDING_REMOVE: {
      return {
        ...state,
        isGraderVendingRemoveSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_REMOVE_SUCCESS: {
      return {
        ...state,
        isGraderVendingRemoveSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_REMOVE_FAIL: {
      return {
        ...state,
        isGraderVendingRemoveSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_PUBLISH: {
      return {
        ...state,
        isGraderVendingPublishSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_PUBLISH_SUCCESS: {
      return {
        ...state,
        isGraderVendingPublishSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_PUBLISH_FAIL: {
      return {
        ...state,
        isGraderVendingPublishSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_RESIDENT_ONLY: {
      return {
        ...state,
        isGraderVendingResidentOnlySuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_RESIDENT_ONLY_SUCCESS: {
      return {
        ...state,
        isGraderVendingResidentOnlySuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_RESIDENT_ONLY_FAIL: {
      return {
        ...state,
        isGraderVendingResidentOnlySuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_REBOOT: {
      return {
        ...state,
        isGraderVendingRebootSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_REBOOT_SUCCESS: {
      return {
        ...state,
        isGraderVendingRebootSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_REBOOT_FAIL: {
      return {
        ...state,
        isGraderVendingRebootSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK: {
      return {
        ...state,
        isGraderVendingUnlockMaglockSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK_SUCCESS: {
      return {
        ...state,
        isGraderVendingUnlockMaglockSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK_FAIL: {
      return {
        ...state,
        isGraderVendingUnlockMaglockSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_CURRENT_STATUS: {
      return {
        ...state,
        isGraderVendingCurrentStatusSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_CURRENT_STATUS_SUCCESS: {
      return {
        ...state,
        isGraderVendingCurrentStatusSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_CURRENT_STATUS_FAIL: {
      return {
        ...state,
        isGraderVendingCurrentStatusSuccess: false
      };
    }
    
    case actionTypes.GRADER_VENDING_STOP_SERVICE: {
      return {
        ...state,
        isGraderVendingStopServiceSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_STOP_SERVICE_SUCCESS: {
      return {
        ...state,
        isGraderVendingStopServiceSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_STOP_SERVICE_FAIL: {
      return {
        ...state,
        isGraderVendingStopServiceSuccess: false
      };
    }
    
    case actionTypes.GRADER_VENDING_START_SERVICE: {
      return {
        ...state,
        isGraderVendingStartServiceSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_START_SERVICE_SUCCESS: {
      return {
        ...state,
        isGraderVendingStartServiceSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_START_SERVICE_FAIL: {
      return {
        ...state,
        isGraderVendingStartServiceSuccess: false
      };
    }
    
    case actionTypes.GRADER_VENDING_TEST_CONNECTION: {
      return {
        ...state,
        isGraderVendingTestConnectionSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_TEST_CONNECTION_SUCCESS: {
      return {
        ...state,
        isGraderVendingTestConnectionSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_TEST_CONNECTION_FAIL: {
      return {
        ...state,
        isGraderVendingTestConnectionSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_CURRENT_WEIGHT: {
      return {
        ...state,
        isGraderVendingCurrentWeightSuccess: false,
        isGraderVendingCurrentWeightFail: false,
        graderVendingCurrentWeight: null
      };
    }

    case actionTypes.GRADER_VENDING_CURRENT_WEIGHT_SUCCESS: {
      return {
        ...state,
        isGraderVendingCurrentWeightSuccess: true,
        graderVendingCurrentWeight: action.data
      };
    }

    case actionTypes.GRADER_VENDING_CURRENT_WEIGHT_FAIL: {
      return {
        ...state,
        isGraderVendingCurrentWeightSuccess: false,
        isGraderVendingCurrentWeightFail: true
      };
    }
    
    case actionTypes.VENDING_LANDFILL_DISTANCE: {
      return {
        ...state,
        vendingLandfillDistance: null,
        isProcessVendingLandfillDistance: true
      };
    }

    case actionTypes.VENDING_LANDFILL_DISTANCE_SUCCESS: {
      return {
        ...state,
        vendingLandfillDistance: action.data,
        isProcessVendingLandfillDistance: false
      };
    }

    case actionTypes.VENDING_LANDFILL_DISTANCE_FAIL: {
      return {
        ...state,
        isProcessVendingLandfillDistance: false
      };
    }
    
    case actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD: {
      
      return {
        ...state,
        isLoadingAudioTTSList: true,
        audioTTSList: []
      };
    }

    case actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD_SUCCESS: {
  
      return {
        ...state,
        isLoadingAudioTTSList: false,
        audioTTSList: action.data
      };
    }

    case actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD_FAIL: {
      return {
        ...state,
        isLoadingAudioTTSList: false,
      };
    }

    
    case actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE: {
      return {
        ...state,
        isGraderVendingAudioTTSUpdateSuccess: false
      };
    }

    case actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE_SUCCESS: {
      return {
        ...state,
        isGraderVendingAudioTTSUpdateSuccess: true
      };
    }

    case actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE_FAIL: {
      return {
        ...state,
        isGraderVendingAudioTTSUpdateSuccess: false
      };
    }

    
    case actionTypes.RESET_MQTT_TOPIC: {
      return {
        ...state,
        isProcessResetMQTTTopic: true,
        isResetMQTTTopicSuccess: false,
      };
    }

    case actionTypes.RESET_MQTT_TOPIC_SUCCESS: {
      return {
        ...state,
        isProcessResetMQTTTopic: false,
        isResetMQTTTopicSuccess: true,
      };
    }

    case actionTypes.RESET_MQTT_TOPIC_FAIL: {
      return {
        ...state,
        isProcessResetMQTTTopic: false,
        isResetMQTTTopicSuccess: false,
      };
    }

    case actionTypes.CANCEL_STUCK_EXPRESS_ORDER: {
      return {
        ...state,
        isProcessCancelStuckExpressOrder: true,
        isCancelStuckExpressOrderSuccess: false,
      };
    }

    case actionTypes.CANCEL_STUCK_EXPRESS_ORDER_SUCCESS: {
      return {
        ...state,
        isProcessCancelStuckExpressOrder: false,
        isCancelStuckExpressOrderSuccess: true,
      };
    }

    case actionTypes.CANCEL_STUCK_EXPRESS_ORDER_FAIL: {
      return {
        ...state,
        isProcessCancelStuckExpressOrder: false,
        isCancelStuckExpressOrderSuccess: false,
      };
    }

    
    case actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD: {
      return {
        ...state,
        isLoadingDRVMGradingOrderDashboard: true,
        DRVMGradingOrderDashboard: {},
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD_SUCCESS: {
      return {
        ...state,
        isLoadingDRVMGradingOrderDashboard: false,
        DRVMGradingOrderDashboard: action.data
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD_FAIL: {
      return {
        ...state,
        isLoadingDRVMGradingOrderDashboard: false
      };
    }

    
    case actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD: {
      return {
        ...state,
        isLoadingDRVMGradingVendingDashboard: true,
        DRVMGradingVendingDashboard: {},
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD_SUCCESS: {
      return {
        ...state,
        isLoadingDRVMGradingVendingDashboard: false,
        DRVMGradingVendingDashboard: action.data
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD_FAIL: {
      return {
        ...state,
        isLoadingDRVMGradingVendingDashboard: false
      };
    }
    
    case actionTypes.LOAD_DRVM_GRADING_STATUS_CHART: {
      return {
        ...state,
        isLoadingDRVMGradingStatusChart: true,
        DRVMGradingStatusChart: {},
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_STATUS_CHART_SUCCESS: {
      return {
        ...state,
        isLoadingDRVMGradingStatusChart: false,
        DRVMGradingStatusChart: action.data
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_STATUS_CHART_FAIL: {
      return {
        ...state,
        isLoadingDRVMGradingStatusChart: false
      };
    }
    
    case actionTypes.LOAD_DRVM_GRADING_ORDER_CHART: {
      return {
        ...state,
        isLoadingDRVMGradingOrderChart: true,
        isLoadDRVMGradingOrderChartSuccess: false,
        DRVMGradingOrderChart: [],
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_ORDER_CHART_SUCCESS: {
      return {
        ...state,
        isLoadingDRVMGradingOrderChart: false,
        isLoadDRVMGradingOrderChartSuccess: true,
        DRVMGradingOrderChart: action.data
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_ORDER_CHART_FAIL: {
      return {
        ...state,
        isLoadingDRVMGradingOrderChart: false
      };
    }
    
    case actionTypes.LOAD_DRVM_GRADING_RANKING: {
      return {
        ...state,
        isLoadingDRVMGradingRanking: true,
        DRVMGradingRankingVending: [],
        DRVMGradingRankingLocation: [],
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_RANKING_SUCCESS: {
      return {
        ...state,
        isLoadingDRVMGradingRanking: false,
        DRVMGradingRankingVending: (action.data.machine_ranking) ? action.data.machine_ranking : [],
        DRVMGradingRankingLocation: (action.data.location_ranking) ? action.data.location_ranking : [],
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_RANKING_FAIL: {
      return {
        ...state,
        isLoadingDRVMGradingRanking: false
      };
    }
    
    case actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART: {
      return {
        ...state,
        isLoadingDRVMGradingCategoryChart: true,
        DRVMGradingCategoryChart: [],
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART_SUCCESS: {
      return {
        ...state,
        isLoadingDRVMGradingCategoryChart: false,
        DRVMGradingCategoryChart: action.data
      };
    }

    case actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART_FAIL: {
      return {
        ...state,
        isLoadingDRVMGradingCategoryChart: false
      };
    }

    /* ===== VENDING COUNCIL ===== */
    case actionTypes.VENDING_COUNCIL_LIST: {
      return {
        ...state,
        isLoadingVendingCouncilList: true,
        vendingCouncilList: []
      };
    }

    case actionTypes.VENDING_COUNCIL_LIST_SUCCESS: {
      return {
        ...state,
        isLoadingVendingCouncilList: false,
        vendingCouncilList: action.data
      };
    }

    case actionTypes.VENDING_COUNCIL_LIST_FAIL: {
      return {
        ...state,
        isLoadingVendingCouncilList: false
      };
    }

    case actionTypes.VENDING_COUNCIL_CREATE: {
      return {
        ...state,
        isVendingCouncilCreateSuccess: false,
        isVendingCouncilCreateFail: false
      };
    }

    case actionTypes.VENDING_COUNCIL_CREATE_SUCCESS: {
      return {
        ...state,
        isVendingCouncilCreateSuccess: true
      };
    }

    case actionTypes.VENDING_COUNCIL_CREATE_FAIL: {
      return {
        ...state,
        isVendingCouncilCreateFail: true
      };
    }

    case actionTypes.VENDING_COUNCIL_UPDATE: {
      return {
        ...state,
        isVendingCouncilUpdateSuccess: false,
        isVendingCouncilUpdateFail: false
      };
    }

    case actionTypes.VENDING_COUNCIL_UPDATE_SUCCESS: {
      return {
        ...state,
        isVendingCouncilUpdateSuccess: true
      };
    }

    case actionTypes.VENDING_COUNCIL_UPDATE_FAIL: {
      return {
        ...state,
        isVendingCouncilUpdateFail: true
      };
    }

    case actionTypes.VENDING_COUNCIL_REMOVE: {
      return {
        ...state,
        isVendingCouncilRemoveSuccess: false,
        isVendingCouncilRemoveFail: false
      };
    }

    case actionTypes.VENDING_COUNCIL_REMOVE_SUCCESS: {
      return {
        ...state,
        isVendingCouncilRemoveSuccess: true
      };
    }

    case actionTypes.VENDING_COUNCIL_REMOVE_FAIL: {
      return {
        ...state,
        isVendingCouncilRemoveFail: true
      };
    }

    case actionTypes.VENDING_COUNCIL_SET: {
      return {
        ...state,
        isVendingCouncilSetSuccess: false,
        isVendingCouncilSetFail: false
      };
    }

    case actionTypes.VENDING_COUNCIL_SET_SUCCESS: {
      return {
        ...state,
        isVendingCouncilSetSuccess: true
      };
    }

    case actionTypes.VENDING_COUNCIL_SET_FAIL: {
      return {
        ...state,
        isVendingCouncilSetFail: true
      };
    }
    /* ===== END VENDING COUNCIL ===== */


    /* ===== VENDING VERSION ===== */
    case actionTypes.VENDING_VERSION_LIST: {
      let vendingVersionList = cloneDeep(state.vendingVersionList);
      if (
        action.data &&
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        vendingVersionList.offset = action.data.offset;
        vendingVersionList.limit = action.data.limit;
      }

      return {
        ...state,
        vendingVersionList,
        isLoadingVendingVersionList: true
      };
    }

    case actionTypes.VENDING_VERSION_LIST_SUCCESS: {
      let vendingVersionList = cloneDeep(state.vendingVersionList);
      vendingVersionList.data = action.data.data;
      vendingVersionList.meta = {
        page: 1 + state.vendingVersionList.offset / state.vendingVersionList.limit,
        pageSize: state.vendingVersionList.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.vendingVersionList.limit),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        vendingVersionList,
        isLoadingVendingVersionList: false
      };
    }

    case actionTypes.VENDING_VERSION_LIST_FAIL: {
      return {
        ...state,
        isLoadingVendingVersionList: false
      };
    }

    case actionTypes.VENDING_VERSION_UPLOAD: {
      return {
        ...state,
        isVendingVersionUploadSuccess: false,
        isVendingVersionUploadFail: false
      };
    }

    case actionTypes.VENDING_VERSION_UPLOAD_SUCCESS: {
      return {
        ...state,
        isVendingVersionUploadSuccess: true
      };
    }

    case actionTypes.VENDING_VERSION_UPLOAD_FAIL: {
      return {
        ...state,
        isVendingVersionUploadFail: true
      };
    }

    case actionTypes.VENDING_VERSION_SELECT: {
      return {
        ...state,
        isVendingVersionSelectSuccess: false,
        isVendingVersionSelectFail: false
      };
    }

    case actionTypes.VENDING_VERSION_SELECT_SUCCESS: {
      return {
        ...state,
        isVendingVersionSelectSuccess: true
      };
    }

    case actionTypes.VENDING_VERSION_SELECT_FAIL: {
      return {
        ...state,
        isVendingVersionSelectFail: true
      };
    }

    case actionTypes.VENDING_VERSION_SEND: {
      return {
        ...state,
        isVendingVersionSendSuccess: false,
        isVendingVersionSendFail: false
      };
    }

    case actionTypes.VENDING_VERSION_SEND_SUCCESS: {
      return {
        ...state,
        isVendingVersionSendSuccess: true
      };
    }

    case actionTypes.VENDING_VERSION_SEND_FAIL: {
      return {
        ...state,
        isVendingVersionSendFail: true
      };
    }

    case actionTypes.VENDING_VERSION_REMOVE: {
      return {
        ...state,
        isVendingVersionRemoveSuccess: false,
        isVendingVersionRemoveFail: false
      };
    }

    case actionTypes.VENDING_VERSION_REMOVE_SUCCESS: {
      return {
        ...state,
        isVendingVersionRemoveSuccess: true
      };
    }

    case actionTypes.VENDING_VERSION_REMOVE_FAIL: {
      return {
        ...state,
        isVendingVersionRemoveFail: true
      };
    }
    /* ===== END VENDING VERSION ===== */


    /* ===== CATEGORY AI RULES ===== */
    case actionTypes.LOAD_DRVM_RECYCLING_CATEGORY: {
      return {
        ...state,
        drvmRecyclingCategory: []
      };
    }

    case actionTypes.LOAD_DRVM_RECYCLING_CATEGORY_SUCCESS: {
      return {
        ...state,
        drvmRecyclingCategory: action.data
      };
    }

    case actionTypes.LOAD_DRVM_RECYCLING_CATEGORY_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.UPDATE_CATEGORY_RULES: {
      return {
        ...state,
        isUpdateCategoryRulesSuccess: false,
        isUpdateCategoryRulesFail: false
      };
    }

    case actionTypes.UPDATE_CATEGORY_RULES_SUCCESS: {
      return {
        ...state,
        isUpdateCategoryRulesSuccess: true
      };
    }

    case actionTypes.UPDATE_CATEGORY_RULES_FAIL: {
      return {
        ...state,
        isUpdateCategoryRulesFail: true
      };
    }
    /* ===== END CATEGORY AI RULES ===== */

    default:
      return state;
  }
}
